<template>
    <div class="header-container">
        <header style="background: rgb(33, 33, 33);color:white; z-index: 100" v-if="isUserAuthenticated"
            v-show="canViewHeader">
            <nav class="full-header">
                <div class="left-side dflex" style="padding: 0 0 0 2ch;">
                    <div id="navigation-buttons">
                        <div class="go-back-button" @click="goBack">
                            <span class="go-back-button mdi mdi-arrow-left-circle-outline"></span>
                        </div>
                        <div @click="reloadPage" class="header-reload">
                            <span class="mdi mdi-reload"></span>
                        </div>
                    </div>
                    <a class="logo" href="/">
                        <img src="/img/uma_logo/Fondo_Negro_UMA_Blanco_Compressed.png" alt="S"
                            style="height: 79px; width: 350px;  margin: 1rem -2rem 1rem 3rem; transform: scale(0.7);">
                    </a>
                </div>
                <div class="custom-nav-bar dflex"
                    style="padding: 0; margin: 0; width: 100%; justify-content: flex-start;">
                    <ul class="nav-ul" v-if="canViewAtLeastOneNavBarOption">
                        <li class="collapse-nav" v-if="planifierHasAtLeastOneOption">
                            <a class="collapse-header">
                                <span class="mdi mdi-developer-board" style="font-size: 24px !important;"></span>
                                <span>Planificador</span>
                            </a>
                            <ul class="collapse navigation" style="position: absolute">
                                <li v-if="canViewProductionControl">
                                    <a href="/production-control">
                                        <span class="mdi mdi-human-male-board-poll"></span>
                                        <span>Control de producción</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="collapse-nav" v-if="productionHasAtLeastOneOption">
                            <a class="collapse-header">
                                <span class="mdi mdi-factory" style="font-size: 24px !important;"></span>
                                <span>Producción</span>
                            </a>
                            <ul class="collapse navigation" style="position: absolute">
                                <li v-if="canViewOrder">
                                    <a href="/order">
                                        <i class="mdi mdi-clipboard-outline"></i>
                                        <span>Órdenes de producción</span>
                                    </a>
                                </li>
                                <li v-if="canViewReference">
                                    <a href="/reference">
                                        <span class="mdi mdi-cart-outline"></span>
                                        <span>Artículos</span>
                                    </a>
                                </li>
                                <li v-if="canViewMachine">
                                    <a href="/machine">
                                        <span class="mdi mdi-robot-industrial-outline"></span>
                                        <span>Máquinas</span>
                                    </a>
                                </li>
                                <li v-if="canViewOrderReference">
                                    <a href="/monitorization">
                                        <span class="mdi mdi-monitor"></span>
                                        <span>Monitorización</span>
                                    </a>
                                </li>
                                <li v-if="canViewCalendar">
                                    <a href="/calendar">
                                        <span class="mdi mdi-calendar-multiselect"></span>
                                        <span>Calendario</span>
                                    </a>
                                </li>
                                <li class="has-submenu" v-if="personalHasAtLeastOneOption">
                                    <a>
                                        <div class="submenu-navigation-context">
                                            <i class="mdi mdi-account-group"></i>
                                            <span>Personal</span>
                                        </div>
                                        <span class="mdi mdi-chevron-right"></span>
                                    </a>
                                    <ul class="collapse collapse-sub navigation" style="position: absolute">
                                        <li v-if="canViewOperators">
                                            <a href="/operator">
                                                <span class="mdi mdi-account-hard-hat"></span>
                                                <span>Operarios</span>
                                            </a>
                                        </li>
                                        <li v-if="canViewPositions">
                                            <a href="/operator-titles">
                                                <span class="mdi mdi-account-tie"></span>
                                                <span>Puestos</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="collapse-nav" v-if="reportsHasAtLeastOneOption">
                            <a class="collapse-header">
                                <span class="mdi mdi-chart-bar" style="font-size: 24px !important;"></span>
                                <span>Informes</span>
                            </a>
                            <ul class="collapse navigation" style="position: absolute">
                                <li v-if="canViewProductionReports">
                                    <a href="/reporting/confection">
                                        <span class="mdi mdi-finance"></span>
                                        <span>Confección</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="collapse-nav" v-if="configurationHasAtLeastOneOption">
                            <a class="collapse-header">
                                <span class="mdi mdi-cog-outline" style="font-size: 24px !important;"></span>
                                <span>Configuración</span>
                            </a>
                            <ul class="collapse navigation" style="position: absolute">
                                <li v-if="canViewCalendarShiftTemplates">
                                    <a href="/calendar/shifts-templates">
                                        <span class="mdi mdi-calendar-clock"></span>
                                        <span>Plantillas de calendario</span>
                                    </a>
                                </li>
                                <li v-if="canViewAdminConfiguration">
                                    <a href="/configurations">
                                        <span class="mdi mdi-monitor"></span>
                                        <span>Ajustes capacidad productiva</span>
                                    </a>
                                </li>
                                <li class="has-submenu" v-if="securityHasAtLeastOneOption">
                                    <a>
                                        <div class="submenu-navigation-context">
                                            <span class="mdi mdi-shield-lock"></span>
                                            <span>Seguridad</span>
                                        </div>
                                        <span class="mdi mdi-chevron-right"></span>
                                    </a>
                                    <ul class="collapse collapse-sub navigation" style="position: absolute">
                                        <li v-if="canViewUsers">
                                            <a href="/users">
                                                <span class="mdi mdi-account-supervisor"></span>
                                                <span>Usuarios</span>
                                            </a>
                                        </li>
                                        <li v-if="canViewRoles">
                                            <a href="/roles">
                                                <span class="mdi mdi-account-star"></span>
                                                <span>Roles</span>
                                            </a>
                                        </li>
                                        <li v-if="canViewPermissions">
                                            <a href="/permissions">
                                                <span class="mdi mdi-key-outline"></span>
                                                <span>Permisos</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="has-submenu" v-if="digitalTwinHasAtLeastOneOption">
                                    <a>
                                        <div class="submenu-navigation-context">
                                            <span class="mdi mdi-layers"></span>
                                            <span>Gemelo digital</span>
                                        </div>
                                        <span class="mdi mdi-chevron-right"></span>
                                    </a>
                                    <ul class="collapse collapse-sub navigation" style="position: absolute">
                                        <li v-if="canViewDataloggers">
                                            <a href="/dataloggers">
                                                <span class="mdi mdi-antenna"></span>
                                                <span>Dataloggers</span>
                                            </a>
                                        </li>
                                        <li v-if="canViewProductionLine">
                                            <a href="/production-line">
                                                <span class="mdi mdi-robot-industrial"></span>
                                                <span>Líneas de producción</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="custom-nav-bar dflex" style="width: 50ch; margin: 0 10ch 0 0;">
                    <ul class="nav-ul">
                        <li class="collapse-nav">
                            <a class="collapse-header">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                                    <path fill="currentColor"
                                        d="M8 5c-3.3 0-6 2.7-6 6c0 2 1 3.8 2.5 4.8C1.8 17.2 0 19.9 0 23h2c0-3.3 2.7-6 6-6s6 2.7 6 6h2c0-3.2 2.6-5.9 5.8-6h.2c2.5 0 4.6-1.5 5.5-3.6c0 0 0-.1.1-.1c.1-.1.1-.3.1-.4c0-.1 0-.1.1-.2c0-.1.1-.3.1-.4c0-.1 0-.2.1-.3c0-.1 0-.2.1-.3v-.6c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 2 1 3.8 2.5 4.8c-1.5.7-2.7 1.9-3.5 3.3c-.8-1.4-2-2.6-3.5-3.3C13 14.8 14 13 14 11c0-3.3-2.7-6-6-6zm0 2c2.2 0 4 1.8 4 4s-1.8 4-4 4s-4-1.8-4-4s1.8-4 4-4zm14 0c2.2 0 4 1.8 4 4s-1.8 4-4 4s-4-1.8-4-4s1.8-4 4-4zm2.1 11v2.1c-.6.1-1.2.4-1.7.7l-1.5-1.5l-1.4 1.4l1.5 1.5c-.4.5-.6 1.1-.7 1.8H18v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5l1.4 1.4l1.5-1.5c.5.3 1.1.6 1.7.7V32h2v-2.1c.6-.1 1.2-.4 1.7-.7l1.5 1.5l1.4-1.4l-1.5-1.5c.4-.5.6-1.1.7-1.8H32v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5l-1.4-1.4l-1.5 1.5c-.5-.3-1.1-.6-1.7-.7V18h-2zm.9 4c1.7 0 3 1.3 3 3s-1.3 3-3 3s-3-1.3-3-3s1.3-3 3-3zm0 2a.872.872 0 0 0-.367.086a1.138 1.138 0 0 0-.32.227a1.138 1.138 0 0 0-.227.32A.872.872 0 0 0 24 25c0 .125.031.25.086.367c.055.117.133.227.227.32c.093.094.203.172.32.227A.872.872 0 0 0 25 26c.5 0 1-.5 1-1s-.5-1-1-1z" />
                                </svg>
                                <span>
                                    {{ username }}
                                </span>
                            </a>
                            <ul class="collapse navigation" style="position: absolute">
                                <li v-if="canViewAbout">
                                    <a href="/production/about">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24">
                                            <path fill="currentColor"
                                                d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14h-2v-2h2zm0-4h-2V7h2z" />
                                        </svg>
                                        <span>Acerca de UMA</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click="openConfirmModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 1024 1024">
                                            <path fill="currentColor"
                                                d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8c-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9a353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8c47.9 0 94.3 9.3 137.9 27.8c42.2 17.8 80.1 43.4 112.7 75.9c7.9 7.9 15.3 16.1 22.4 24.5c3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82C271.7 82.6 79.6 277.1 82 516.4C84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7c3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z" />
                                        </svg>
                                        <span>Cerrar sesión</span>
                                    </a>
                                    <form id="logout-form" action="/logout" method="POST" style="display: none;">
                                        <input type="hidden" name="_token" :value="token" />
                                    </form>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
        <transition name="slide-fade">
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="contentMessage"
                :closeModal="closeModal"
                :methodForProp="methodForProp"
            />
            <WarningModal
                v-if="showWarningModal"
                :warningMessage="closingSessionMessage"
            />
        </transition>  
    </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import SpeenComponent from "../../common/components/SpeenComponent";
import { mapActions, mapGetters } from "vuex";
import PermissionsConsts from "../../common/permissions";
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import WarningModal from "../../common/components/modals/WarningModal.vue";

export default {
    name: 'HeaderView',
    components: {
        SpeenComponent,
        ActionConfirmModal,
        WarningModal,
    },
    data() {
        return {
            isUserAuthenticated: false,
            isUserOperator: false,
            userId: -1,
            token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            contentMessage: "",
            methodForProp: "",
            showActionConfirmModal: false,
            showWarningModal: false,
            closingSessionMessage: '',
        };
    },
    methods: {
        ...mapActions(["initializeUserPermissions", "updateIsUserSuperadmin", "updateIsUserAdmin", "updateUsername"]),
        getHeaderVueData() {
            axios.get('/api/header/vue-data')
                .then(response => {
                    this.isUserAuthenticated = true;
                    this.isUserOperator = response.data.isUserOperator;
                    this.userId = response.data.userId;
                    this.initializeUserPermissions(response.data.userPermissions);
                    this.updateIsUserSuperadmin(response.data.isUserSuperadmin);
                    this.updateIsUserAdmin(response.data.isUserAdmin);
                    this.updateUsername(response.data.username);
                })
                .catch(error => {
                    if (error.response && error.response.data.errorMessage === 'Unauthenticated.') {
                        if (window.location.pathname !== '/login') {
                            this.isUserAuthenticated = true;
                        }
                        showCustomErrorSweetAlert(error.response.data);
                    }
                })
                .finally(() => {
                    this.prepareEchoEvents();
                });
        },
        goBack() {
            window.history.length > 1 ? window.history.back() : window.location.href = "/";
        },
        reloadPage() {
            window.location.reload();
        },
        openConfirmModal()
        {
            this.contentMessage = "¿Está seguro de que desea cerrar sesión?";
            this.methodForProp = this.logout;
            this.showActionConfirmModal = true;
        },
        closeModal() {
            this.showActionConfirmModal = false;
        },
        logout() {
            const logoutForm = document.getElementById('logout-form');
            const tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = 'authToken';
            tokenInput.value = CookieUtils.getCookie('AuthTokenValue');
            logoutForm.appendChild(tokenInput);

            CookieUtils.setCookie('AuthTokenValue', 'Sin token', 86400);

            logoutForm.submit();
        },
        logoutUser(message) {
            this.showWarningModal = true;
            this.closingSessionMessage = message;
            setTimeout(() => {
                this.logout();
            }, 3000);
        },
        stillNotFinished() {
            Swal.fire({
                title: 'Página no disponible',
                text: 'Esta funcionalidad aún no está disponible.',
                icon: 'info',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#27884F',
            })
        },
        prepareEchoEvents() {
            window.Echo.private(EchoChannels.PRIVATE.USER(this.userId))
                .listen(EchoEvents.CLOSE_USER_SESSION_EVENT, (data) => {
                    if (this.isUserSuperadmin) return;
                    this.logoutUser(data.message);
                })
        },
    },
    computed: {
        ...mapGetters(['userPermissions', 'userHasPermission', 'isUserSuperadmin', 'username']),
        canViewHeader() {
            return this.userHasPermission(PermissionsConsts.HEADER_SHOW);
        },
        canViewAtLeastOneNavBarOption() {
            return this.planifierHasAtLeastOneOption ||
                this.productionHasAtLeastOneOption ||
                this.reportsHasAtLeastOneOption ||
                this.configurationHasAtLeastOneOption;
        },
        planifierHasAtLeastOneOption() {
            return this.canViewProductionControl;
        },
        canViewProductionControl() {
            return this.userHasPermission(PermissionsConsts.PLANNER_PRODUCTION_CONTROL_VIEW);
        },
        productionHasAtLeastOneOption() {
            return this.canViewOrder ||
                this.canViewOrderReference ||
                this.canViewCalendar ||
                this.canViewMachine ||
                this.canViewReference ||
                this.personalHasAtLeastOneOption;
        },
        canViewOrder() {
            return this.userHasPermission(PermissionsConsts.PRODUCTION_ORDER_INDEX_VIEW);
        },
        canViewOrderReference() {
            return this.userHasPermission(PermissionsConsts.PRODUCTION_MONITORIZATION_VIEW);
        },
        canViewCalendar() {
            return this.userHasPermission(PermissionsConsts.CALENDAR_VIEW);
        },
        canViewReference() {
            return this.userHasPermission(PermissionsConsts.REFERENCE_VIEW); 
        },
        canViewMachine() {
            return this.userHasPermission(PermissionsConsts.MACHINE_VIEW);
        },
        personalHasAtLeastOneOption() {
            return this.canViewOperators ||
                this.canViewPositions;
        },
        canViewOperators() {
            return this.userHasPermission(PermissionsConsts.OPERATOR_VIEW);
        },
        canViewPositions() {
            return this.userHasPermission(PermissionsConsts.OPERATOR_TITLE_VIEW);
        },
        reportsHasAtLeastOneOption() {
            return this.canViewProductionReports;
        },
        canViewProductionReports() {
            return this.userHasPermission(PermissionsConsts.REPORTING_CONFECTION_VIEW);
        },
        configurationHasAtLeastOneOption() {
            return this.canViewCalendarShiftTemplates ||
                this.canViewAdminConfiguration ||
                this.securityHasAtLeastOneOption ||
                this.digitalTwinHasAtLeastOneOption;
        },
        canViewAdminConfiguration() {
            return this.userHasPermission(PermissionsConsts.ADMIN_CONFIGURATIONS);
        },
        canViewCalendarShiftTemplates() {
            return this.userHasPermission(PermissionsConsts.SHIFT_TEMPLATE_INDEX_VIEW);
        },
        securityHasAtLeastOneOption() {
            return this.canViewUsers ||
                this.canViewRoles ||
                this.canViewPermissions;
        },
        canViewUsers() {
            return this.userHasPermission(PermissionsConsts.USER_INDEX_VIEW);
        },
        canViewRoles() {
            return this.userHasPermission(PermissionsConsts.ROLES_INDEX_VIEW);
        },
        canViewPermissions() {
            return this.isUserSuperadmin;
        },
        digitalTwinHasAtLeastOneOption() {
            return this.canViewDataloggers ||
                this.canViewProductionLine;
        },
        canViewDataloggers() {
            return this.isUserSuperadmin;
        },
        canViewProductionLine() {
            return this.isUserSuperadmin;
        },
        canViewAbout() {
            return this.userHasPermission(PermissionsConsts.HEADER_ABOUT_VIEW);
        },
    },
    mounted() {
        this.getHeaderVueData();
    },
};
</script>